import { inter, manrope } from './fonts';

export const typography = {
  fontFamily: [
    inter.style.fontFamily,
    manrope.style.fontFamily,
    'Arial',
    'sans-serif',
  ],
  'display-large': {
    fontFamily: manrope.style.fontFamily,
    fontSize: '3.5625rem',
    fontWeight: 700,
    lineHeight: 1.123,
  },
  'display-medium': {
    fontFamily: manrope.style.fontFamily,
    fontSize: '2.8125rem',
    fontWeight: 700,
    lineHeight: 1.156,
  },
  'display-small': {
    fontFamily: manrope.style.fontFamily,
    fontSize: '2.25rem',
    fontWeight: 700,
    lineHeight: 1.222,
  },
  'headline-large': {
    fontFamily: manrope.style.fontFamily,
    fontSize: '2.25rem',
    fontWeight: 700,
    lineHeight: 1.25,
  },
  'headline-medium': {
    fontFamily: manrope.style.fontFamily,
    fontSize: '1.75rem',
    fontWeight: 700,
    lineHeight: 1.286,
  },
  'headline-small': {
    fontFamily: manrope.style.fontFamily,
    fontSize: '1.5rem',
    fontWeight: 700,
    lineHeight: 1.333,
  },
  'title-large': {
    fontFamily: manrope.style.fontFamily,
    fontSize: '1.25rem',
    fontWeight: 700,
    lineHeight: 1.4,
  },
  'title-medium': {
    fontFamily: manrope.style.fontFamily,
    fontSize: '1rem',
    fontWeight: 700,
    lineHeight: 1.5,
  },
  'title-small': {
    fontFamily: manrope.style.fontFamily,
    fontSize: '0.875rem',
    fontWeight: 700,
    lineHeight: 1.429,
  },
  'label-large': {
    fontFamily: inter.style.fontFamily,
    fontSize: '1rem',
    fontWeight: 600,
    lineHeight: 1.5,
  },
  'label-medium': {
    fontFamily: inter.style.fontFamily,
    fontSize: '0.875rem',
    fontWeight: 600,
    lineHeight: 1.429,
  },
  'label-small': {
    fontFamily: inter.style.fontFamily,
    fontSize: '0.75rem',
    fontWeight: 600,
    lineHeight: 1.333,
  },
  'label-tiny': {
    fontFamily: inter.style.fontFamily,
    fontSize: '0.625rem',
    fontWeight: 600,
    lineHeight: 1.2,
  },
  'body-large': {
    fontFamily: inter.style.fontFamily,
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  'body-medium': {
    fontFamily: inter.style.fontFamily,
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: 1.429,
  },
  'body-small': {
    fontFamily: inter.style.fontFamily,
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: 1.333,
  },
  'body-tiny': {
    fontFamily: inter.style.fontFamily,
    fontSize: '0.625rem',
    fontWeight: 400,
    lineHeight: 1.2,
  },
};